"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgLcenseService", {
    enumerable: true,
    get: function() {
        return OrgLcenseService;
    }
});
const _common = require("@nestjs/common");
const _constants = require("../constants");
const _helpers = require("~/helpers");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _models = require("~/models");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OrgLcenseService = class OrgLcenseService {
    async licenseGet() {
        const license = await _models.Store.get(_constants.NC_LICENSE_KEY);
        return {
            key: license == null ? void 0 : license.value
        };
    }
    async licenseSet(param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/LicenseReq', param);
        await _models.Store.saveOrUpdate({
            value: param.key,
            key: _constants.NC_LICENSE_KEY
        });
        await _Noco.default.loadEEState();
        return true;
    }
};
OrgLcenseService = _ts_decorate([
    (0, _common.Injectable)()
], OrgLcenseService);
